import { Heading, Paragraph } from '@app/shared/ui/atoms/Common';

interface ListItemProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
}

export function ListItem({ imageSrc, imageAlt, title, description }: ListItemProps) {
  return (
    <li className="flex flex-col gap-4 rounded-[10px] bg-[#FFFFFFCC] p-5 pt-3">
      <div className="flex items-center gap-4">
        <img src={imageSrc} alt={imageAlt} className="w-8" />
        <Heading level={4} className="leading-none text-secondary-foreground">
          {title}
        </Heading>
      </div>
      <Paragraph size="sm" className="font-normal leading-[1.2]">
        {description}
      </Paragraph>
    </li>
  );
}
